/**
 * 핀 관련 유틸리티
 *
 * PresenterScreen, ParticipantList, SideSubVideoList 등에서 공통으로 사용하는
 * 핀 복합 키 생성/파싱 함수.
 */

/** 핀 복합 키 생성: 화면 공유는 'userId:screen', 카메라는 'userId' */
export const toPinKey = (userId: string, isScreenShare?: boolean): string =>
  isScreenShare ? `${userId}:screen` : userId;

/** 핀 복합 키 파싱: 'userId:screen' → { userId, isScreenShare: true } */
export const parsePinKey = (pinKey: string): { userId: string; isScreenShare: boolean } => {
  if (pinKey.endsWith(':screen')) {
    return { userId: pinKey.slice(0, -7), isScreenShare: true };
  }
  return { userId: pinKey, isScreenShare: false };
};
